module.exports = __webpack_public_path__ + "img/bg_normal@2x.f0cb43a.png";